var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-element-loading',{attrs:{"active":_vm.active,"is-full-screen":_vm.isFullScreen}},[_c('img',{staticClass:"h-14",attrs:{"src":require("../assets/pikachu.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }